import ButtonVariants from "@core-components/button/ButtonVariants";
import AppThemeIcon from "@core-components/icon/AppThemeIcon";
import Icon from "@core-components/icon/Icon";
import EPublicRoutes from "@core-types/routes.enum";
import useAppLanguage from "@hooks/language/useAppLanguage";
import useAppTranslation from "@hooks/language/useAppTranslation";
import { Group, Text, Title } from "@mantine/core";
import { type ForwardedRef, forwardRef } from "react";
import ReviewContainer from "./ReviewContainer";

const CtaReview = forwardRef((_, ref: ForwardedRef<HTMLDivElement>) => {
  const { t } = useAppTranslation("pages.reviews.cta");
  const { locationUrlBuilder } = useAppLanguage();

  return (
    <ReviewContainer ref={ref}>
      <Title order={3}>{t("title")}</Title>
      <Text>{t("description")}</Text>
      <ButtonVariants.Gradient
        href={locationUrlBuilder(EPublicRoutes.SMURFS_NORMAL)}
        label={
          <Group justify="center">
            <AppThemeIcon className="size-7">
              <Icon.AddToBasket />
            </AppThemeIcon>
            {t("cta")}
          </Group>
        }
      />
    </ReviewContainer>
  );
});

export default CtaReview;
